import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CustomDeadlineRepoService } from './custom-deadline-repo.service';
import { ICustomDeadlineUpdate, ICustomDeadlineSplit } from '@settings/models/index';
import { Periods } from '@settings/settings.constants';

@Injectable({
  providedIn: 'root'
})
export class CustomDeadlineService {
  constructor(private _customDeadlineRepo: CustomDeadlineRepoService) {}

  getCustomDeadline(selectedMonth: Date): Observable<ICustomDeadlineSplit> {
    return this._customDeadlineRepo.getCustomDeadline(this._splitSelectedMonth(selectedMonth)).pipe(
      map((customDeadline) => {
        const splitedData = this._splitCustomDeadline(customDeadline.deadlineDateTime);
        return { ...splitedData, ...customDeadline, restoredDefaultDeadline: false };
      })
    );
  }

  patchCustomDeadline(customDeadlineSplited: ICustomDeadlineSplit): Observable<undefined> {
    return this._customDeadlineRepo.patchCustomDeadline(this._joinSplittedCustomDeadline(customDeadlineSplited));
  }

  getRestoredDeadline(selectedMonth: Date): Observable<ICustomDeadlineSplit> {
    return this._customDeadlineRepo.getRestoredDeadline(this._splitSelectedMonth(selectedMonth)).pipe(
      map((customDeadline) => {
        return { ...this._splitCustomDeadline(customDeadline.dateTime), restoredDefaultDeadline: true };
      })
    );
  }

  private _splitCustomDeadline(deadlineDateTime: string): ICustomDeadlineSplit {
    const date = new Date(deadlineDateTime);
    const hour = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
    const minute = date.getMinutes() === 0 ? '00' : `${date.getMinutes()}`;
    const period = date.getHours() >= 12 ? Periods.PM : Periods.AM;
    return { hour, minute, period, date, deadlineDateTime };
  }

  private _joinSplittedCustomDeadline(customDeadlineSplited: ICustomDeadlineSplit): ICustomDeadlineUpdate {
    const date = customDeadlineSplited.date;
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    const hour = customDeadlineSplited.hour.toString().padStart(2, '0');
    const selectedMonth = this._splitSelectedMonth(customDeadlineSplited.selectedMonth);
    const restoredDefaultDeadline = customDeadlineSplited.restoredDefaultDeadline;
    const formattedDate = `${month}/${day}/${year}`;
    const dateTime = `${formattedDate} ${hour}:${customDeadlineSplited.minute} ${customDeadlineSplited.period}`;
    return { dateTime, year: selectedMonth.year, month: selectedMonth.month, restoredDefaultDeadline };
  }

  private _splitSelectedMonth(selectedMonth: Date): { year: string; month: string } {
    const year = selectedMonth.getFullYear().toString();
    const month = (selectedMonth.getMonth() + 1).toString().padStart(2, '0');
    return { year, month };
  }
}
